import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import { Box, CircularProgress, Typography } from '@mui/material';
import { VpButton } from '@vp-ui';
import { UploadCloud } from 'react-feather';
import { Icon } from 'rsuite';

export const VpDropzone = ({
  accept,
  title,
  subtitle,
  logoUrl,
  onDropAccepted = () => {},
  onDropRejected = () => {},
  multiple,
  maxSize,
  onRemove = () => {},
  hasFile = true,
  loading,
}) => {
  const [isHover, setIsHover] = useState(false);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept,
    onDropAccepted,
    onDropRejected,
    multiple,
    maxSize,
    disabled: loading,
  });

  return (
    <div>
      <Box
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        {...getRootProps()}
        sx={{
          p: 2,
          border: '1px dashed #C7C7CC',
          borderColor:
            (isDragActive || isHover) && !loading && (!hasFile || logoUrl)
              ? 'vpColors.blueMain'
              : 'grey.400',
          bgcolor:
            (isDragActive || isHover) && !loading && (!hasFile || logoUrl)
              ? 'vpColors.blueLighter'
              : 'transparent',
          borderRadius: '8px',
          color: 'text.secondary',
          textAlign: 'center',
          cursor: 'pointer',
          height: 200,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <input {...getInputProps()} />
        {logoUrl ? (
          <>
            <img height="100px" src={logoUrl} alt="Preview" />
            <Typography sx={{ mt: '8px', color: 'grey.500', fontSize: 14 }}>
              Click or drop a file to replace this image
            </Typography>
          </>
        ) : loading ? (
          <CircularProgress color="primary" />
        ) : hasFile ? (
          <span>
            <Icon icon="attachment" size="lg" />
            File uploaded. Remove file to upload a different one.
            <VpButton
              sx={{ m: 'auto', display: 'block' }}
              color="error"
              onClick={(e) => {
                e.stopPropagation();
                onRemove();
              }}
            >
              Remove
            </VpButton>
          </span>
        ) : (
          <>
            <UploadCloud color="#8E8E93" strokeWidth={1} size={42} />
            <Typography sx={{ mt: '4px', fontSize: 14 }}>{title}</Typography>
            <Typography sx={{ color: 'grey.500', fontSize: 14 }}>{subtitle}</Typography>
            <VpButton sx={{ mt: '16px' }} variant={isHover ? 'contained' : 'outlined'}>
              Select File
            </VpButton>
          </>
        )}
      </Box>
    </div>
  );
};

VpDropzone.propTypes = {
  accept: PropTypes.arrayOf(PropTypes.string),
  logoUrl: PropTypes.string,
  onDropAccepted: PropTypes.func,
  onDropRejected: PropTypes.func,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  multiple: PropTypes.bool,
  maxSize: PropTypes.number,
  onRemove: PropTypes.func,
  hasFile: PropTypes.bool,
  loading: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/vp-ui/inputs/VpDropzone.jsx